import { Component, EventEmitter, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-modal-logout",
  standalone: true,
  imports: [],
  templateUrl: "./modal-logout.component.html",
  styleUrl: "./modal-logout.component.css",
})
export class ModalLogoutComponent {
  @Output() closeLogout = new EventEmitter<any>();
  constructor(public activeModal: NgbActiveModal) {}

  logout() {
    this.closeLogout.emit(true);
  }
}
